var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOutlinedInfoGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 15C0 6.716 6.716 0 15 0C23.284 0 30 6.716 30 15C30 23.284 23.284 30 15 30C6.716 30 0 23.284 0 15ZM18.1855 26.9693C20.285 26.3938 22.1947 25.273 23.7208 23.7208C25.2731 22.1947 26.3939 20.2849 26.9693 18.1855C27.5445 16.086 27.554 13.8718 26.9966 11.7675C26.4391 9.66325 25.3346 7.74408 23.7953 6.20475C22.2561 4.66543 20.3368 3.56093 18.2326 3.0035C16.1283 2.44607 13.9141 2.45555 11.8146 3.03085C9.7151 3.60635 7.80542 4.7271 6.27935 6.27935C4.72705 7.80535 3.60625 9.71517 3.03085 11.8146C2.45555 13.9141 2.44607 16.1283 3.0035 18.2326C3.561 20.3368 4.6655 22.256 6.20475 23.7953C7.744 25.3347 9.6633 26.4392 11.7675 26.9966C13.8718 27.554 16.086 27.5445 18.1855 26.9693ZM17.0836 8.89995C17.0836 10.0505 16.1509 10.9833 15.0003 10.9833C13.8497 10.9833 12.917 10.0505 12.917 8.89995C12.917 7.74938 13.8497 6.81665 15.0003 6.81665C16.1509 6.81665 17.0836 7.74938 17.0836 8.89995ZM16.7322 14.6078V21.4746C16.7322 22.0938 16.4018 22.666 15.8656 22.9757C15.3293 23.2853 14.6686 23.2853 14.1322 22.9757C13.596 22.666 13.2656 22.0938 13.2656 21.4746V14.6078C13.2656 13.9886 13.596 13.4163 14.1322 13.1068C14.6686 12.7971 15.3293 12.7971 15.8656 13.1068C16.4018 13.4163 16.7322 13.9886 16.7322 14.6078Z",
    fill: "#4a685D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutlinedInfoGreen);
export default __webpack_public_path__ + "static/media/outlined-info-green.fc321fdc.svg";
export { ForwardRef as ReactComponent };